module.controller('planSamplingListCtrl', [ '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'roleService', 'ASEBIOL_CONSTANTS', 'securityService', 'Identity', planSamplingListFn ]);

function planSamplingListFn($scope, $rootScope, $state, planSamplingService, alertService, roleService, ASEBIOL_CONSTANTS, securityService, Identity) {

	$scope.emptyFilter = {
		visible : true,
		client : []
	};
	$scope.filter = (JSON.parse(JSON.stringify($scope.emptyFilter)));
	$scope.planSamplings = [];
	$scope.pagination = {
		current : 1,
		total : 0
	};
	var idUser = undefined;

	/**
	 * 
	 * @param page
	 */
	$scope.search = function(page) {
		$scope.loading = true;

		page = page == undefined ? 1 : page;
		$scope.pagination.current = page;

		var filter = {};
		filter.offset = (page - 1) * $rootScope.pageSize;
		filter.limit = $rootScope.pageSize;
		filter.visible = $scope.filter.visible;

		if ($scope.filter.name) {
			filter.name = $scope.filter.name;
		}

		if ($scope.filter.client && $scope.filter.client.selected && $scope.filter.client.selected.length > 0) {
			filter.idClient = $scope.filter.client.selected[0].id;
		}

		if (angular.isDefined(idUser))
			filter.idUser = idUser;

		filter.orderby = [ "startDate desc" ];

		if(Identity.isClient()){
			// consulta de planes para el rol cliente
			planSamplingService.searchPlanSamplingForUserClient(securityService.getLoggedUserId() ,filter).then(function(response) {
				$scope.loading = false;
				var result = response.getData();

				$scope.planSamplings = result.results;
				// se combierten las fechas de string a date
				$scope.planSamplings.forEach(function(e) {
					e.startDate = moment(e.startDate, ASEBIOL_CONSTANTS.DATE_FORMAT_MOMENT).toDate();
				});

				$scope.pagination.total = result.totalRegisters;

			}, function(response) {
				$scope.loading = false;
			});
		}
		else{
			// consulta de planes para rol
			planSamplingService.searchPlanSampling(filter).then(function(response) {
				$scope.loading = false;
				var result = response.getData();

				$scope.planSamplings = result.results;
				// se combierten las fechas de string a date
				$scope.planSamplings.forEach(function(e) {
					e.startDate = moment(e.startDate, ASEBIOL_CONSTANTS.DATE_FORMAT_MOMENT).toDate();
				});

				$scope.pagination.total = result.totalRegisters;

			}, function(response) {
				$scope.loading = false;
			});
		}
		
	};

	/**
	 * 
	 */
	$scope.clearFilters = function() {
		$scope.filter = (JSON.parse(JSON.stringify($scope.emptyFilter)));
	};

	if (securityService.hasRole(ROLE_TYPE.CLIENT.code)) {
		
		/* Load user data session */
		securityService.loadUserLoggedInfo().then(function(response) {
			var userSession = response;
			
			if (userSession.client == null) {
				alertService.showWarning('Usuario no tienen asociado ningún cliente');
			} else {
				// $scope.filter.client.selected = [response.getData().client];
				idUser = response.id;
				$scope.search(1);
				// console.log($scope.filter.client);
			}
		}, function(response) {
			alertService.showWarning('Error cargando información de sesión del usuario');
		});
		
	} else {
		$scope.search(1);
	}

};